import React, { useState } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from "redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ValueCardInfo from "./ValueCardInfo";
import { setValueCardInfo, setSelectedValueCardBenefits } from "../../redux/actions/valueCardAction";

import './OpenValueCardBlock.scss';


const OpenValueCardBlock = ({t, setValueCardInfo, setSelectedValueCardBenefits}) => {
  const [cardNumber, setCardNumber] = useState('');
  const [nextButtonState, setNextButtonState] = useState(false);
  const [selectedBenefits, setSelectedBenefits] = useState([]);
  const [valuecardIsOpened, setValuecardIsOpened] = useState(false);
  const [valuecardClientInfo, setValuecardClientInfo] = useState(null);

  const toggleCartPopup = () => {
    if (valuecardIsOpened)
    {
      setCardNumber('');      
      setSelectedBenefits([]);
      setNextButtonState(false);
      setValuecardClientInfo(null);
    }
    setValuecardIsOpened(!valuecardIsOpened);
  };

  const onClickOk = () => {
    setValueCardInfo(valuecardClientInfo);
    setSelectedValueCardBenefits(selectedBenefits);
    setValuecardIsOpened(!valuecardIsOpened);
    setNextButtonState(false);
  }

  return (
    <>
      <div onClick={toggleCartPopup} className={"open-valuecard-btn"}>
        <div className={"order-label"}>{t('open-valuecard-btn.label')}</div>
      </div>
      <div className={`mobile-cart-popup ${valuecardIsOpened ? "opened" : ""} ${!nextButtonState ? "next" : ""}`}>
        <div className={"hide-btn"} onClick={toggleCartPopup}>
          <FontAwesomeIcon icon="chevron-down" />
        </div>
        <div className={`popup-content`}>
          <ValueCardInfo 
            cardNumber={cardNumber}
            setCardNumber={setCardNumber}
            selectedBenefits={selectedBenefits}
            setSelectedBenefits={setSelectedBenefits}
            valuecardClientInfo={valuecardClientInfo}
            setValuecardClientInfo={setValuecardClientInfo}
            nextButtonState = {nextButtonState}
            setNextButtonState = {setNextButtonState}
            onClickOk={onClickOk}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const {
    selectedValueCardBenefits
  } = state;

  return {
    selectedValueCardBenefits
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setValueCardInfo,
      setSelectedValueCardBenefits
    },
    dispatch
  );

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(OpenValueCardBlock)
);

